<template>
    <div>
    <v-app-bar app flat light dense>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-spacer/>
      <v-toolbar-title class="font-weight-light headline">TOMWEDGE</v-toolbar-title>
      <v-toolbar-title class="font-weight-black headline">IMAGES</v-toolbar-title>
      <v-spacer/>
      
    </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
      >
        
        <v-list
          nav
          dense
        >
          <v-list-item>
            
            <v-list-item-icon>
              <v-icon>mdi-camera</v-icon>
              </v-list-item-icon>
            <v-list-item-title class="font-weight-light">TOMWEDGE<span class="font-weight-black">IMAGES</span></v-list-item-title>
              
            
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item-group
            v-model="group"
            active-class="blue--text text--accent-4"
          >
            <v-list-item v-for="link in links" 
            :key="link.name"
            :to="{
              name: link.route,
              params: { pagename: link.title, filter: link.filter },
            }">
              <v-list-item-icon>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>


        </v-list>
        
        <v-divider></v-divider>

        <v-btn
        v-for="footerlink in footerlinks"
        :key="footerlink.link"
        :href="footerlink.link"
        :color="footerlink.colour"
        class="mx-4"
        icon
        target="_blank"
      >
        <v-icon>{{ footerlink.icon }}</v-icon>
      </v-btn>

      </v-navigation-drawer>

    </div>
</template>

<script>
    export default {
        props: {
            links: {},
            footerlinks: {}
        },
        data: () => (
            {
                drawer : false,
                group: null
            }
        )
        
    }
</script>

<style lang="scss" scoped>

</style>